// extracted by mini-css-extract-plugin
export default {"main":"SkeletonLoading_main__qD5P8","shine-lines":"SkeletonLoading_shine-lines__YISHG"};